import { cn } from '@latitude/token-utils';
import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentPropsWithoutRef } from 'react';
import { labelVariants } from 'variants/label-variants';

/**
 * Represents a label component used in forms.
 *
 * @component
 * @example
 * ```tsx
 * <Label htmlFor="username">Username</Label>
 * ```
 */
export type FieldLabelProps = ComponentPropsWithoutRef<
  typeof LabelPrimitive.Root
> & {
  className?: string;
  error: boolean;
  disabled: boolean;
};

export const FieldLabel = ({
  className,
  error,
  disabled,
  ...props
}: FieldLabelProps) => {
  return (
    <LabelPrimitive.Root
      className={cn(
        [
          'font-comp-form-label-font-family',
          'text-font-comp-form-label-font-size',
          'font-comp-form-label-font-weight',
          'leading-font-comp-form-label-line-height',
          labelVariants({ error, disabled }),
        ],
        className,
      )}
      {...props}
    />
  );
};
